// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Dy-2","footer":"ReportModalFilter_footer__1xRwQ"};